import React from 'react';
import { useState, useEffect,useRef } from 'react';
import { useParams } from 'react-router-dom';
import axios from 'axios';
import useLoader from "../Hook/useLoader";
import SnackBar from "./SnackBar";
import AppInsight from "../AppInsight";
import { getMSID, getToken } from "../common";

 
const ViewHistoryPopup = (props) => {
 
    const [openModal, setOpenModal] = useState(false);
    const [loader, showLoader, hideLoader] = useLoader();
    const [data,setData]=useState([]);
    const params = useParams();
    const msid = getMSID();

     
    useEffect(() => {
        setOpenModal(props.openViewHistory);
    }, [props.openViewHistory, props.popupChange]);
 
    useEffect(()=>{
        handleGetApiComment();
    },[props.popupChange])
 
 
    const closePopup = () => {
        setOpenModal(false);
    }
 
    const handleGetApiComment = () => {
        try {
            CallGetCommentApi();
        }
        catch (error) {
          AppInsight.trackEvent({ name: `PNA Frontend => handleGetApiComment in ViewHistoryPopup, msid=>${msid}`, properties: { errorMessage: error.message } });
        }
      };
 
    const CallGetCommentApi=async()=>{
        const token = getToken();
         const header = {
            headers: {
                "Authorization": `Bearer ${token}`,
            },
        };
     try{
        AppInsight.trackEvent({ name: `PNA Frontend=>CallGetCommentApi API Call started, msid=> ${msid}`});
        const response=await axios.get(
        process.env.REACT_APP_API_URI +"CommentsData?key="+params.pkey,header);
        AppInsight.trackEvent({ name: `PNA Frontend=>CallGetCommentApi API Call started, msid=> ${msid}`});
        const processedData=response.data.commentsData.map( item=>({...item,
        date:formatDate(new Date(item.creation_date)),
        time:formatTime(new Date(item.creation_date)),
        image:(item.screenshot===null||item.screenshot==="")?(item.screenshot):("data:image/png;base64,"+item.screenshot),
    }))   
        setData(processedData);
    }
    catch(error){
      AppInsight.trackEvent({ name: `PNA Frontend => callDownloadDocumentsAPI, msid=>${msid}`, properties: { errorMessage: error.message } });
    }
    }
 
    const formatDate=(date)=>{
        const optionDate={
            year:'numeric',
            month:'2-digit',
            day:'2-digit'
        };
        return date.toLocaleDateString('en-US',optionDate).replace(/[/]/g,'-');
    }
    const formatTime=(date)=>{
        const time = new Date(date.getTime());
        const optionTime={
            minute:'numeric',
            second:'numeric',
            hour:'numeric',
        }
        const month= String((time.getMonth())+1).padStart(2,'0');
         const dayOfMonth= String((time.getDate())).padStart(2,'0');
        const year = String(time.getFullYear());
        const hour = String(time.getHours()).padStart(2, '0');
        const min = String(time.getMinutes()).padStart(2, '0');
        const seconds = String(time.getSeconds()).padStart(2,'0');
        return `${month}-${dayOfMonth}-${year}  ${hour}:${min}:${seconds} CST`;
    }
   
   
   
    return (
        <>
            {
                openModal &&
                <div className="modal1" id="modalpopup" >
                    {loader}
                    <div className="modal-content" >
 
                        <div>
                            <div style={{ display: 'inline-block', marginLeft: '0%' }}>
                                <label style={{ textAlign: 'center', fontWeight: 'bold' }}>Previous Comments</label>
                            </div>
                            <div style={{ display: 'inline-block', marginLeft: '80%' }}>
                                <label className="cursorPointer" style={{ textAlign: 'center', fontWeight: 'bold' }} onClick={closePopup}>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" class="bi bi-x" viewBox="0 0 16 16">
                                        <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708" />
                                    </svg>
                                </label>
                            </div>
                        </div>
                        <br></br>
 
                        <div className="previousComments marginBottom">
                            {data.map((item,index)=>{
                                let status=item.status;
                                if(status==="sent back")
                                {
                                    status="Send Back";
                                }
                                else if(status==="approved")
                                {
                                    status="Approved";
                                }
                                else if(status==="denied")
                                {
                                    status="Denied";
                                }

                                return(
                            <div  key={index}>
                            <div><label className="commentName">{item.creator}</label> (<label>{status}</label>) : <label>{item.comment}</label></div>
                            <div> <label>{item.time}</label></div>                            
                            <img src={item.image} style={{maxWidth:'100%'}}/>
                            <hr/>
                        </div>
                                )
                            })}
                        </div>
                    </div>
                </div>
            } 
        </>
    )
 }
 
export default ViewHistoryPopup
 
 
 